import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Row, Col, FormGroup, Input, Button } from 'reactstrap'
import Form from '../../../modules/Form'
import { pinError } from '../../../actions/adminActions'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { push } from 'connected-react-router'
import Cookies from 'universal-cookie'
const cookies = new Cookies()

class AdminPin extends Component {
  constructor (props) {
    super(props)
    this.checkPin = this.checkPin.bind(this)
    this.pinRef = React.createRef()
  }

  componentDidMount () {
    if (!this.props.admin.pin) {
      this.props.loginPage()
    }
  }

  checkPin (e) {
    if (String(this.pinRef.current.value) === String(this.props.admin.pin)) {
      cookies.set('ps_admin_tfa', '1', { path: '/' })
      this.props.adminPage()
    } else {
      this.props.pinError()
    }
  }

  render () {
    return (

      <div>
        <Container>
          <Row>
            <Col xs={{ size: 10, offset: 1 }} sm={{ size: 8, offset: 2 }} className='form-container'>
              <Form submit={this.checkPin} >
                <h2>Enter security pin</h2>
                <FormGroup>
                  <Input type='number' maxLength='4' innerRef={this.pinRef} name='pin' id={'pin'} required placeholder='PIN' />
                  <div className='invalid-feedback' />
                </FormGroup>
                <Button color='primary'>Submit</Button>
              </Form>
            </Col>
          </Row>
        </Container>

      </div>
    )
  }
};

AdminPin.propTypes = {
  admin: PropTypes.object,
  loginPage: PropTypes.func,
  adminPage: PropTypes.func,
  pinError: PropTypes.func
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loginPage: () => push('/admin/login'),
      adminPage: () => push('/admin'),
      pinError
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminPin))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminLogin/AdminPin.jsx